<template>
  <approve-list-detail/>
</template>

<script>
import approveListDetail from '../../components/approvalsCommonDetail'

export default {
  components: {
    approveListDetail,
  },
}
</script>
